import React from 'react';

import { string } from 'prop-types';

import './PromoWarningMessage.scss';

export const PromoWarningMessage = ({ message }) => {
  return (
    <div className="promo-warning-message">
      <span>{message}</span>
    </div>
  );
};

PromoWarningMessage.displayName = 'PromoWarningMessage';

PromoWarningMessage.propTypes = {
  message: string.isRequired
};
